import { render } from "./AddNewPageView.vue?vue&type=template&id=d2d71ba2&scoped=true"
import script from "./AddNewPageView.vue?vue&type=script&lang=js"
export * from "./AddNewPageView.vue?vue&type=script&lang=js"

import "./AddNewPageView.vue?vue&type=style&index=0&id=d2d71ba2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d71ba2"]])

export default __exports__